import { useState } from "react";

const useListState = <T extends string>({ tagList = [] }: { tagList: T[] }) => {
	const [state, setIsOpen] = useState<{ [K in T]: boolean }>(tagList.reduce((acc, el) => ({ ...acc, [el]: false }), {}) as { [K in T]: boolean }); // состояние открытия/закрытия тега

	const toggleState = (tagName: T) => () => {
		setIsOpen((prev) => ({
			...prev,
			[tagName]: !prev[tagName],
		}));
	};

	const setNewList = (newList: { [K in T]: boolean }) => {
		setIsOpen(newList);
	};

	return {
		state,
		toggleState,
		setNewList,
	};
};

export default useListState;
